import React from 'react';
import type { TranslationKey } from 'hooks/useTranslation';
import { useTranslation } from '../../../../../../hooks';
import styles from './Analytics.module.css';
import { Typography } from '@mui/material';

export interface AmountsListItem {
  key: TranslationKey;
  value?: number;
  dotClass?: string;
}

interface AmountsListProps {
  items: AmountsListItem[];
  className?: string;
  style?: React.CSSProperties;
}

export const AmountsList = ({ items, className, style }: AmountsListProps) => {
  const { t } = useTranslation();

  return (
    <>
      {items.map(({ key, value, dotClass }) => (
        <div
          key={key}
          className={`${styles.amountsLine} ${className || ''}`}
          style={style}
        >
          <div>
            {dotClass && <span className={dotClass}>&#9679; </span>}
            {t(key)}
          </div>
          {value !== undefined && (
            <Typography className={styles.amountSum}>
              {Math.round(value).toLocaleString('ru-RU')}
            </Typography>
          )}
        </div>
      ))}
    </>
  );
};
